module.exports = __webpack_public_path__ + "img/fungeomine.08d8ab0f.jpg";